export enum ApiTypes {
  AdminApi = 'admin-api'
}
